export const VAT = 0.1;
export const PRONOUNS_OTHER = 221120003;

// https://dev.azure.com/gorelate/Forum%20Alpbach/_workitems/edit/5266/
const orgId = () => {
  return document.getElementById("app").dataset.crmOrgId;
  // Prod: 85bf3021-5793-45b0-83e8-431d40d04d47
  // Test: 0bb3f4eb-e0a9-4ad3-9af4-7d287b86da5f
  // Dev: 08525d77-43c2-4b76-9c8f-351411b219b8
};

export const MARKETING_FORM_CONFIG = {
  publicCrmBaseUrl: "https://public-eur.mkt.dynamics.com",
  publishedFormUrl: `https://assets-eur.mkt.dynamics.com/${orgId()}/digitalassets/standaloneforms/29692dc9-180b-f011-bae2-7c1e5212dee9`,
  publicFormSubmissionUrl: `/api/v1.0/orgs/${orgId()}/landingpageforms/forms/29692dc9-180b-f011-bae2-7c1e5212dee9`,
  fields: {
    consentSubmissionValues: "consentsubmissionvalues",
    firstName: "firstname",
    lastName: "lastname",
    genderCode: "gendercode",
    emailAddress1: "emailaddress1",
    preferredEmailType: "new_bevorzugteemail",
    languageLookup: "navax_language",
  },
  values: {
    channelEmail: "Email",
    optedIn: "Opted In",
    optInWhenChecked: "true",
    preferredEmailBusiness: "100000001",
  },
  consent: {
    complianceSettingsId: "a9e18f53-8bef-ef11-9341-7c1e5273d98b",
    newsletterPurposeId: "08065a00-8aef-ef11-9341-7c1e5273d98b",
    newsletterTopicId: "5a8a73f4-8bef-ef11-9341-7c1e5273d98b",
    labels: {
      newsletterOptIn:
        "I would like to receive newsletters and updates from the European Forum Alpbach (EFA) via email ",
      generalNewsletter: "General Newsletter",
    },
  },
};

export const MARKETING_FORM_FIELD_MAP = {
  firstname: "firstname",
  lastname: "lastname",
  gendercode: "gendercode",
  emailaddress1: "emailaddress1",
  new_bevorzugteemail: "new_bevorzugteemail",
  navax_language: "navax_language",
};
